import { Body } from "../Typography";
import {
  CollaboratorActions,
  CollaboratorContent,
  CollaboratorRowContainer,
  CollaboratorTextContent,
} from "./__styles__/CollaboratorList";
import { Collaborator, PermissionOption } from "./types";

interface ReadOnlyCollaboratorRowProps {
  collaborator: Collaborator;
  permissionOptions: PermissionOption[];
}

export const ReadOnlyCollaboratorRow = ({
  collaborator,
  permissionOptions,
}: ReadOnlyCollaboratorRowProps) => {
  const currentPermissionLabel =
    permissionOptions
      .find(opt => opt.value === collaborator.permission)
      ?.label?.toLowerCase() || "can view";

  return (
    <CollaboratorRowContainer>
      <CollaboratorContent>
        <CollaboratorTextContent>
          <Body type="emphasis" size="default" color="contentPrimary">
            {collaborator.name}
          </Body>
          {collaborator.description && (
            <Body type="regular" size="default" color="contentSecondary">
              {collaborator.description}
            </Body>
          )}
        </CollaboratorTextContent>
      </CollaboratorContent>
      <CollaboratorActions>
        <Body type="link" size="default" color="contentSecondary">
          {currentPermissionLabel}
        </Body>
      </CollaboratorActions>
    </CollaboratorRowContainer>
  );
};
